import { isIndiaCompliance } from "../../../managers/common/CommonUtil";
import { CONSTANTS, COUNTRY_CODE, INPUT_TYPE, NONE_OPTION, TOOLTIP_TEXT } from "../../../constants/Constant";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { INPUT_VIEW_DIRECTION } from "../../SequenceNumberFormat/Other";

export const CONFIG_SECTION = {
	EMPLOYEE_DETAILS: "EMPLOYEE_DETAILS",
	ADDRESS: "ADDRESS",
	COMPENSATION: "COMPENSATION",
	EMPLOYEE_PAYMENT_DETAILS: "EMPLOYEE_PAYMENT_DETAILS",
	BILLING_RATE: "BILLING_RATE",
	SALARY_ADVANCE: "SALARY_ADVANCE"
};

export const Genders = [
	{
		id: "male",
		name: "Male",
	},
	{
		id: "female",
		name: "Female",
	},
];

export const MaritalStatus = [
	{
		id: "single",
		name: "Single",
	},
	{
		id: "married",
		name: "Married",
	},
	{
		id: "separated",
		name: "Separated",
	},
	{
		id: "divorce",
		name: "Divorce",
	},
	{
		id: "widowed",
		name: "Widowed",
	},
];

export const EmployeeTypes = [
	{
		id: "1",
		name: "Full-time",
	},
	{
		id: "2",
		name: "Part-time",
	},
	{
		id: "3",
		name: "Casual",
	},
	{
		id: "4",
		name: "Shift Workers",
	},
	{
		id: "5",
		name: "Probation",
	},
	{
		id: "6",
		name: "Outworkers",
	},
	{
		id: "7",
		name: "Intern",
	},
	{
		id: "8",
		name: "Contractor",
	},
	{
		id: "9",
		name: "Consultant",
	},
];

export const CompensationPeriod = [
	{
		id: "365",
		name: "Per Year",
	},
	{
		id: "30",
		name: "Per Month",
	},
	{
		id: "hourly",
		name: "Per Hour",
	},
];

export const CompensationPeriodUS = [
	{
		id: "365",
		name: "Per Year",
	},
	{
		id: "30",
		name: "Per Month",
	},
	{
		id: "hourly",
		name: "Per Hour",
	},
	{
		id: "weekly",
		name: "Per Week",
	},
];

export const CompensationPeriodMYSG = [
	{
		id: "365",
		name: "Per Year",
	},
	{
		id: "30",
		name: "Per Month",
	},
	{
		id: "hourly",
		name: "Per Hour",
	},
];

export const PAYMENT_METHOD_TYPE = {
	DIRECT_DEPOSIT: "directDeposit",
	CASH: "cash",
	CHEQUE: "cheque",
};

export const PaymentMethods = [
	{
		id: "directDeposit",
		name: "Direct Deposit",
	},
	{
		id: "cash",
		name: "Cash",
	},
	{
		id: "cheque",
		name: "Cheque",
	},
	{
		id: "upi",
		name: "UPI",
	},
];

export const USPaymentMethods = [
	{
		id: "directDeposit",
		name: "Direct Deposit",
	},
	{
		id: "cash",
		name: "Cash",
	},
	{
		id: "cheque",
		name: "Check",
	},
];

export const AccountTypes = [
	{
		id: "currentAccount",
		name: "Current Account",
	},
	{
		id: "savingsAccount",
		name: "Savings Account",
	},
];

export const AccountTypesUS = [
	{
		id: "currentAccount",
		name: "Checking Account",
	},
	{
		id: "savingsAccount",
		name: "Savings Account",
	},
];

export const IN_STATES = [
	{
		code: "AN",
		name: "Andaman and Nicobar Islands",
	},
	{
		code: "AP",
		name: "Andhra Pradesh",
	},
	{
		code: "AR",
		name: "Arunachal Pradesh",
	},
	{
		code: "AS",
		name: "Assam",
	},
	{
		code: "BR",
		name: "Bihar",
	},
	{
		code: "CG",
		name: "Chandigarh",
	},
	{
		code: "CH",
		name: "Chhattisgarh",
	},
	{
		code: "DH",
		name: "Dadra and Nagar Haveli",
	},
	{
		code: "DD",
		name: "Daman and Diu",
	},
	{
		code: "DL",
		name: "Delhi",
	},
	{
		code: "GA",
		name: "Goa",
	},
	{
		code: "GJ",
		name: "Gujarat",
	},
	{
		code: "HR",
		name: "Haryana",
	},
	{
		code: "HP",
		name: "Himachal Pradesh",
	},
	{
		code: "JK",
		name: "Jammu and Kashmir",
	},
	{
		code: "JH",
		name: "Jharkhand",
	},
	{
		code: "KA",
		name: "Karnataka",
	},
	{
		code: "KL",
		name: "Kerala",
	},
	{
		code: "LA",
		name: "Ladakh",
	},
	{
		code: "LD",
		name: "Lakshadweep",
	},
	{
		code: "MP",
		name: "Madhya Pradesh",
	},
	{
		code: "MH",
		name: "Maharashtra",
	},
	{
		code: "MN",
		name: "Manipur",
	},
	{
		code: "ML",
		name: "Meghalaya",
	},
	{
		code: "MZ",
		name: "Mizoram",
	},
	{
		code: "NL",
		name: "Nagaland",
	},
	{
		code: "OR",
		name: "Odisha",
	},
	{
		code: "PY",
		name: "Puducherry",
	},
	{
		code: "PB",
		name: "Punjab",
	},
	{
		code: "RJ",
		name: "Rajasthan",
	},
	{
		code: "SK",
		name: "Sikkim",
	},
	{
		code: "TN",
		name: "Tamil Nadu",
	},
	{
		code: "TS",
		name: "Telangana",
	},
	{
		code: "TR",
		name: "Tripura",
	},
	{
		code: "UP",
		name: "Uttar Pradesh",
	},
	{
		code: "UK",
		name: "Uttarakhand",
	},
	{
		code: "WB",
		name: "West Bengal",
	},
];

export const Countries = [
	{
		name: "Afghanistan",
		currencyCode: "AFN",
		code: "AF",
		dial_code: "+93",
		timezone: "UTC+04:30",
	},
	{
		name: "Åland Islands",
		currencyCode: "EUR",
		code: "AX",
		dial_code: "+358",
		timezone: "UTC+02:00",
	},
	{
		name: "Albania",
		currencyCode: "ALL",
		code: "AL",
		dial_code: "+355",
		timezone: "UTC+01:00",
	},
	{
		name: "Algeria",
		currencyCode: "DZD",
		code: "DZ",
		dial_code: "+213",
		timezone: "UTC+01:00",
	},
	{
		name: "American Samoa",
		currencyCode: "USD",
		code: "AS",
		dial_code: "+1684",
		timezone: "GMT-11:00",
	},
	{
		name: "Andorra",
		currencyCode: "EUR",
		code: "AD",
		dial_code: "+376",
		timezone: "UTC+01:00",
	},
	{
		name: "Angola",
		currencyCode: "AOA",
		code: "AO",
		dial_code: "+244",
		timezone: "UTC+01:00",
	},
	{
		name: "Anguilla",
		currencyCode: "XCD",
		code: "AI",
		dial_code: "+1264",
		timezone: "GMT-04:00",
	},
	{
		name: "Antarctica",
		currencyCode: "AUD",
		code: "AQ",
		dial_code: "+672",
		timezone: "GMT-03:00",
	},
	{
		name: "Antigua and Barbuda",
		currencyCode: "XCD",
		code: "AG",
		dial_code: "+1268",
		timezone: "GMT-04:00",
	},
	{
		name: "Argentina",
		currencyCode: "ARS",
		code: "AR",
		dial_code: "+54",
		timezone: "GMT-03:00",
	},
	{
		name: "Armenia",
		currencyCode: "AMD",
		code: "AM",
		dial_code: "+374",
		timezone: "UTC+04:00",
	},
	{
		name: "Aruba",
		currencyCode: "AWG",
		code: "AW",
		dial_code: "+297",
		timezone: "GMT-04:00",
	},
	{
		name: "Australia",
		currencyCode: "AUD",
		code: "AU",
		dial_code: "+61",
		timezone: "UTC+05:00",
	},
	{
		name: "Austria",
		currencyCode: "EUR",
		code: "AT",
		dial_code: "+43",
		timezone: "UTC+01:00",
	},
	{
		name: "Azerbaijan",
		currencyCode: "AZN",
		code: "AZ",
		dial_code: "+994",
		timezone: "UTC+04:00",
	},
	{
		name: "Bahamas",
		currencyCode: "BSD",
		code: "BS",
		dial_code: "+1242",
		timezone: "GMT-05:00",
	},
	{
		name: "Bahrain",
		currencyCode: "BHD",
		code: "BH",
		dial_code: "+973",
		timezone: "UTC+03:00",
	},
	{
		name: "Bangladesh",
		currencyCode: "BDT",
		code: "BD",
		dial_code: "+880",
		timezone: "UTC+06:00",
	},
	{
		name: "Barbados",
		currencyCode: "BBD",
		code: "BB",
		dial_code: "+1246",
		timezone: "GMT-04:00",
	},
	{
		name: "Belarus",
		currencyCode: "BYN",
		code: "BY",
		dial_code: "+375",
		timezone: "UTC+03:00",
	},
	{
		name: "Belgium",
		currencyCode: "EUR",
		code: "BE",
		dial_code: "+32",
		timezone: "UTC+01:00",
	},
	{
		name: "Belize",
		currencyCode: "BZD",
		code: "BZ",
		dial_code: "+501",
		timezone: "GMT-06:00",
	},
	{
		name: "Benin",
		currencyCode: "XOF",
		code: "BJ",
		dial_code: "+229",
		timezone: "UTC+01:00",
	},
	{
		name: "Bermuda",
		currencyCode: "BMD",
		code: "BM",
		dial_code: "+1441",
		timezone: "GMT-04:00",
	},
	{
		name: "Bhutan",
		currencyCode: "BTN",
		code: "BT",
		dial_code: "+975",
		timezone: "UTC+06:00",
	},
	{
		name: "Bolivia (Plurinational State of)",
		currencyCode: "BOB",
		code: "BO",
		dial_code: "+591",
		timezone: "GMT-04:00",
	},
	{
		name: "Bonaire, Sint Eustatius and Saba",
		currencyCode: "USD",
		code: "BQ",
		dial_code: "+5997",
		timezone: "GMT-04:00",
	},
	{
		name: "Bosnia and Herzegovina",
		currencyCode: "BAM",
		code: "BA",
		dial_code: "+387",
		timezone: "UTC+01:00",
	},
	{
		name: "Botswana",
		currencyCode: "BWP",
		code: "BW",
		dial_code: "+267",
		timezone: "UTC+02:00",
	},
	{
		name: "Bouvet Island",
		currencyCode: "NOK",
		code: "BV",
		dial_code: "+",
		timezone: "UTC+01:00",
	},
	{
		name: "Brazil",
		currencyCode: "BRL",
		code: "BR",
		dial_code: "+55",
		timezone: "GMT-05:00",
	},
	{
		name: "British Indian Ocean Territory",
		currencyCode: "USD",
		code: "IO",
		dial_code: "+246",
		timezone: "UTC+06:00",
	},
	{
		name: "United States Minor Outlying Islands",
		currencyCode: "USD",
		code: "UM",
		dial_code: "+",
		timezone: "GMT-11:00",
	},
	{
		name: "Virgin Islands (British)",
		currencyCode: null,
		code: "VG",
		dial_code: "+1284",
		timezone: "GMT-04:00",
	},
	{
		name: "Virgin Islands (U.S.)",
		currencyCode: "USD",
		code: "VI",
		dial_code: "+1 340",
		timezone: "GMT-04:00",
	},
	{
		name: "Brunei Darussalam",
		currencyCode: "BND",
		code: "BN",
		dial_code: "+673",
		timezone: "UTC+08:00",
	},
	{
		name: "Bulgaria",
		currencyCode: "BGN",
		code: "BG",
		dial_code: "+359",
		timezone: "UTC+02:00",
	},
	{
		name: "Burkina Faso",
		currencyCode: "XOF",
		code: "BF",
		dial_code: "+226",
		timezone: "GMT",
	},
	{
		name: "Burundi",
		currencyCode: "BIF",
		code: "BI",
		dial_code: "+257",
		timezone: "UTC+02:00",
	},
	{
		name: "Cambodia",
		currencyCode: "KHR",
		code: "KH",
		dial_code: "+855",
		timezone: "UTC+07:00",
	},
	{
		name: "Cameroon",
		currencyCode: "XAF",
		code: "CM",
		dial_code: "+237",
		timezone: "UTC+01:00",
	},
	{
		name: "Canada",
		currencyCode: "CAD",
		code: "CA",
		dial_code: "+1",
		timezone: "GMT-08:00",
	},
	{
		name: "Cabo Verde",
		currencyCode: "CVE",
		code: "CV",
		dial_code: "+238",
		timezone: "GMT-01:00",
	},
	{
		name: "Cayman Islands",
		currencyCode: "KYD",
		code: "KY",
		dial_code: "+1345",
		timezone: "GMT-05:00",
	},
	{
		name: "Central African Republic",
		currencyCode: "XAF",
		code: "CF",
		dial_code: "+236",
		timezone: "UTC+01:00",
	},
	{
		name: "Chad",
		currencyCode: "XAF",
		code: "TD",
		dial_code: "+235",
		timezone: "UTC+01:00",
	},
	{
		name: "Chile",
		currencyCode: "CLP",
		code: "CL",
		dial_code: "+56",
		timezone: "GMT-06:00",
	},
	{
		name: "China",
		currencyCode: "CNY",
		code: "CN",
		dial_code: "+86",
		timezone: "UTC+08:00",
	},
	{
		name: "Christmas Island",
		currencyCode: "AUD",
		code: "CX",
		dial_code: "+61",
		timezone: "UTC+07:00",
	},
	{
		name: "Cocos (Keeling) Islands",
		currencyCode: "AUD",
		code: "CC",
		dial_code: "+61",
		timezone: "UTC+06:30",
	},
	{
		name: "Colombia",
		currencyCode: "COP",
		code: "CO",
		dial_code: "+57",
		timezone: "GMT-05:00",
	},
	{
		name: "Comoros",
		currencyCode: "KMF",
		code: "KM",
		dial_code: "+269",
		timezone: "UTC+03:00",
	},
	{
		name: "Congo",
		currencyCode: "XAF",
		code: "CG",
		dial_code: "+242",
		timezone: "UTC+01:00",
	},
	{
		name: "Congo (Democratic Republic of the)",
		currencyCode: "CDF",
		code: "CD",
		dial_code: "+243",
		timezone: "UTC+01:00",
	},
	{
		name: "Cook Islands",
		currencyCode: "NZD",
		code: "CK",
		dial_code: "+682",
		timezone: "GMT-10:00",
	},
	{
		name: "Costa Rica",
		currencyCode: "CRC",
		code: "CR",
		dial_code: "+506",
		timezone: "GMT-06:00",
	},
	{
		name: "Croatia",
		currencyCode: "HRK",
		code: "HR",
		dial_code: "+385",
		timezone: "UTC+01:00",
	},
	{
		name: "Cuba",
		currencyCode: "CUC",
		code: "CU",
		dial_code: "+53",
		timezone: "GMT-05:00",
	},
	{
		name: "Curaçao",
		currencyCode: "ANG",
		code: "CW",
		dial_code: "+599",
		timezone: "GMT-04:00",
	},
	{
		name: "Cyprus",
		currencyCode: "EUR",
		code: "CY",
		dial_code: "+357",
		timezone: "UTC+02:00",
	},
	{
		name: "Czech Republic",
		currencyCode: "CZK",
		code: "CZ",
		dial_code: "+420",
		timezone: "UTC+01:00",
	},
	{
		name: "Denmark",
		currencyCode: "DKK",
		code: "DK",
		dial_code: "+45",
		timezone: "GMT-04:00",
	},
	{
		name: "Djibouti",
		currencyCode: "DJF",
		code: "DJ",
		dial_code: "+253",
		timezone: "UTC+03:00",
	},
	{
		name: "Dominica",
		currencyCode: "XCD",
		code: "DM",
		dial_code: "+1767",
		timezone: "GMT-04:00",
	},
	{
		name: "Dominican Republic",
		currencyCode: "DOP",
		code: "DO",
		dial_code: "+1809",
		timezone: "GMT-04:00",
	},
	{
		name: "Ecuador",
		currencyCode: "USD",
		code: "EC",
		dial_code: "+593",
		timezone: "GMT-06:00",
	},
	{
		name: "Egypt",
		currencyCode: "EGP",
		code: "EG",
		dial_code: "+20",
		timezone: "UTC+02:00",
	},
	{
		name: "El Salvador",
		currencyCode: "USD",
		code: "SV",
		dial_code: "+503",
		timezone: "GMT-06:00",
	},
	{
		name: "Equatorial Guinea",
		currencyCode: "XAF",
		code: "GQ",
		dial_code: "+240",
		timezone: "UTC+01:00",
	},
	{
		name: "Eritrea",
		currencyCode: "ERN",
		code: "ER",
		dial_code: "+291",
		timezone: "UTC+03:00",
	},
	{
		name: "Estonia",
		currencyCode: "EUR",
		code: "EE",
		dial_code: "+372",
		timezone: "UTC+02:00",
	},
	{
		name: "Ethiopia",
		currencyCode: "ETB",
		code: "ET",
		dial_code: "+251",
		timezone: "UTC+03:00",
	},
	{
		name: "Falkland Islands (Malvinas)",
		currencyCode: "FKP",
		code: "FK",
		dial_code: "+500",
		timezone: "GMT-04:00",
	},
	{
		name: "Faroe Islands",
		currencyCode: "DKK",
		code: "FO",
		dial_code: "+298",
		timezone: "UTC+00:00",
	},
	{
		name: "Fiji",
		currencyCode: "FJD",
		code: "FJ",
		dial_code: "+679",
		timezone: "UTC+12:00",
	},
	{
		name: "Finland",
		currencyCode: "EUR",
		code: "FI",
		dial_code: "+358",
		timezone: "UTC+02:00",
	},
	{
		name: "France",
		currencyCode: "EUR",
		code: "FR",
		dial_code: "+33",
		timezone: "GMT-10:00",
	},
	{
		name: "French Guiana",
		currencyCode: "EUR",
		code: "GF",
		dial_code: "+594",
		timezone: "GMT-03:00",
	},
	{
		name: "French Polynesia",
		currencyCode: "XPF",
		code: "PF",
		dial_code: "+689",
		timezone: "GMT-10:00",
	},
	{
		name: "French Southern Territories",
		currencyCode: "EUR",
		code: "TF",
		dial_code: "+",
		timezone: "UTC+05:00",
	},
	{
		name: "Gabon",
		currencyCode: "XAF",
		code: "GA",
		dial_code: "+241",
		timezone: "UTC+01:00",
	},
	{
		name: "Gambia",
		currencyCode: "GMD",
		code: "GM",
		dial_code: "+220",
		timezone: "UTC+00:00",
	},
	{
		name: "Georgia",
		currencyCode: "GEL",
		code: "GE",
		dial_code: "+995",
		timezone: "GMT-05:00",
	},
	{
		name: "Germany",
		currencyCode: "EUR",
		code: "DE",
		dial_code: "+49",
		timezone: "UTC+01:00",
	},
	{
		name: "Ghana",
		currencyCode: "GHS",
		code: "GH",
		dial_code: "+233",
		timezone: "GMT",
	},
	{
		name: "Gibraltar",
		currencyCode: "GIP",
		code: "GI",
		dial_code: "+350",
		timezone: "UTC+01:00",
	},
	{
		name: "Greece",
		currencyCode: "EUR",
		code: "GR",
		dial_code: "+30",
		timezone: "UTC+02:00",
	},
	{
		name: "Greenland",
		currencyCode: "DKK",
		code: "GL",
		dial_code: "+299",
		timezone: "GMT-04:00",
	},
	{
		name: "Grenada",
		currencyCode: "XCD",
		code: "GD",
		dial_code: "+1473",
		timezone: "GMT-04:00",
	},
	{
		name: "Guadeloupe",
		currencyCode: "EUR",
		code: "GP",
		dial_code: "+590",
		timezone: "GMT-04:00",
	},
	{
		name: "Guam",
		currencyCode: "USD",
		code: "GU",
		dial_code: "+1671",
		timezone: "UTC+10:00",
	},
	{
		name: "Guatemala",
		currencyCode: "GTQ",
		code: "GT",
		dial_code: "+502",
		timezone: "GMT-06:00",
	},
	{
		name: "Guernsey",
		currencyCode: "GBP",
		code: "GG",
		dial_code: "+44",
		timezone: "UTC+00:00",
	},
	{
		name: "Guinea",
		currencyCode: "GNF",
		code: "GN",
		dial_code: "+224",
		timezone: "GMT",
	},
	{
		name: "Guinea-Bissau",
		currencyCode: "XOF",
		code: "GW",
		dial_code: "+245",
		timezone: "GMT",
	},
	{
		name: "Guyana",
		currencyCode: "GYD",
		code: "GY",
		dial_code: "+592",
		timezone: "GMT-04:00",
	},
	{
		name: "Haiti",
		currencyCode: "HTG",
		code: "HT",
		dial_code: "+509",
		timezone: "GMT-05:00",
	},
	{
		name: "Heard Island and McDonald Islands",
		currencyCode: "AUD",
		code: "HM",
		dial_code: "+",
		timezone: "UTC+05:00",
	},
	{
		name: "Holy See",
		currencyCode: "EUR",
		code: "VA",
		dial_code: "+379",
		timezone: "UTC+01:00",
	},
	{
		name: "Honduras",
		currencyCode: "HNL",
		code: "HN",
		dial_code: "+504",
		timezone: "GMT-06:00",
	},
	{
		name: "Hong Kong",
		currencyCode: "HKD",
		code: "HK",
		dial_code: "+852",
		timezone: "UTC+08:00",
	},
	{
		name: "Hungary",
		currencyCode: "HUF",
		code: "HU",
		dial_code: "+36",
		timezone: "UTC+01:00",
	},
	{
		name: "Iceland",
		currencyCode: "ISK",
		code: "IS",
		dial_code: "+354",
		timezone: "GMT",
	},
	{
		name: "India",
		currencyCode: "INR",
		code: "IN",
		dial_code: "+91",
		timezone: "UTC+05:30",
	},
	{
		name: "Indonesia",
		currencyCode: "IDR",
		code: "ID",
		dial_code: "+62",
		timezone: "UTC+07:00",
	},
	{
		name: "Côte d'Ivoire",
		currencyCode: "XOF",
		code: "CI",
		dial_code: "+225",
		timezone: "GMT",
	},
	{
		name: "Iran (Islamic Republic of)",
		currencyCode: "IRR",
		code: "IR",
		dial_code: "+98",
		timezone: "UTC+03:30",
	},
	{
		name: "Iraq",
		currencyCode: "IQD",
		code: "IQ",
		dial_code: "+964",
		timezone: "UTC+03:00",
	},
	{
		name: "Ireland",
		currencyCode: "EUR",
		code: "IE",
		dial_code: "+353",
		timezone: "GMT",
	},
	{
		name: "Isle of Man",
		currencyCode: "GBP",
		code: "IM",
		dial_code: "+44",
		timezone: "UTC+00:00",
	},
	{
		name: "Israel",
		currencyCode: "ILS",
		code: "IL",
		dial_code: "+972",
		timezone: "UTC+02:00",
	},
	{
		name: "Italy",
		currencyCode: "EUR",
		code: "IT",
		dial_code: "+39",
		timezone: "UTC+01:00",
	},
	{
		name: "Jamaica",
		currencyCode: "JMD",
		code: "JM",
		dial_code: "+1876",
		timezone: "GMT-05:00",
	},
	{
		name: "Japan",
		currencyCode: "JPY",
		code: "JP",
		dial_code: "+81",
		timezone: "UTC+09:00",
	},
	{
		name: "Jersey",
		currencyCode: "GBP",
		code: "JE",
		dial_code: "+44",
		timezone: "UTC+01:00",
	},
	{
		name: "Jordan",
		currencyCode: "JOD",
		code: "JO",
		dial_code: "+962",
		timezone: "UTC+03:00",
	},
	{
		name: "Kazakhstan",
		currencyCode: "KZT",
		code: "KZ",
		dial_code: "+76",
		timezone: "UTC+05:00",
	},
	{
		name: "Kenya",
		currencyCode: "KES",
		code: "KE",
		dial_code: "+254",
		timezone: "UTC+03:00",
	},
	{
		name: "Kiribati",
		currencyCode: "AUD",
		code: "KI",
		dial_code: "+686",
		timezone: "UTC+12:00",
	},
	{
		name: "Kuwait",
		currencyCode: "KWD",
		code: "KW",
		dial_code: "+965",
		timezone: "UTC+03:00",
	},
	{
		name: "Kyrgyzstan",
		currencyCode: "KGS",
		code: "KG",
		dial_code: "+996",
		timezone: "UTC+06:00",
	},
	{
		name: "Lao People's Democratic Republic",
		currencyCode: "LAK",
		code: "LA",
		dial_code: "+856",
		timezone: "UTC+07:00",
	},
	{
		name: "Latvia",
		currencyCode: "EUR",
		code: "LV",
		dial_code: "+371",
		timezone: "UTC+02:00",
	},
	{
		name: "Lebanon",
		currencyCode: "LBP",
		code: "LB",
		dial_code: "+961",
		timezone: "UTC+02:00",
	},
	{
		name: "Lesotho",
		currencyCode: "LSL",
		code: "LS",
		dial_code: "+266",
		timezone: "UTC+02:00",
	},
	{
		name: "Liberia",
		currencyCode: "LRD",
		code: "LR",
		dial_code: "+231",
		timezone: "GMT",
	},
	{
		name: "Libya",
		currencyCode: "LYD",
		code: "LY",
		dial_code: "+218",
		timezone: "UTC+01:00",
	},
	{
		name: "Liechtenstein",
		currencyCode: "CHF",
		code: "LI",
		dial_code: "+423",
		timezone: "UTC+01:00",
	},
	{
		name: "Lithuania",
		currencyCode: "EUR",
		code: "LT",
		dial_code: "+370",
		timezone: "UTC+02:00",
	},
	{
		name: "Luxembourg",
		currencyCode: "EUR",
		code: "LU",
		dial_code: "+352",
		timezone: "UTC+01:00",
	},
	{
		name: "Macao",
		currencyCode: "MOP",
		code: "MO",
		dial_code: "+853",
		timezone: "UTC+08:00",
	},
	{
		name: "Macedonia (the former Yugoslav Republic of)",
		currencyCode: "MKD",
		code: "MK",
		dial_code: "+389",
		timezone: "UTC+01:00",
	},
	{
		name: "Madagascar",
		currencyCode: "MGA",
		code: "MG",
		dial_code: "+261",
		timezone: "UTC+03:00",
	},
	{
		name: "Malawi",
		currencyCode: "MWK",
		code: "MW",
		dial_code: "+265",
		timezone: "UTC+02:00",
	},
	{
		name: "Malaysia",
		currencyCode: "MYR",
		code: "MY",
		dial_code: "+60",
		timezone: "UTC+08:00",
	},
	{
		name: "Maldives",
		currencyCode: "MVR",
		code: "MV",
		dial_code: "+960",
		timezone: "UTC+05:00",
	},
	{
		name: "Mali",
		currencyCode: "XOF",
		code: "ML",
		dial_code: "+223",
		timezone: "GMT",
	},
	{
		name: "Malta",
		currencyCode: "EUR",
		code: "MT",
		dial_code: "+356",
		timezone: "UTC+01:00",
	},
	{
		name: "Marshall Islands",
		currencyCode: "USD",
		code: "MH",
		dial_code: "+692",
		timezone: "UTC+12:00",
	},
	{
		name: "Martinique",
		currencyCode: "EUR",
		code: "MQ",
		dial_code: "+596",
		timezone: "GMT-04:00",
	},
	{
		name: "Mauritania",
		currencyCode: "MRO",
		code: "MR",
		dial_code: "+222",
		timezone: "GMT",
	},
	{
		name: "Mauritius",
		currencyCode: "MUR",
		code: "MU",
		dial_code: "+230",
		timezone: "UTC+04:00",
	},
	{
		name: "Mayotte",
		currencyCode: "EUR",
		code: "YT",
		dial_code: "+262",
		timezone: "UTC+03:00",
	},
	{
		name: "Mexico",
		currencyCode: "MXN",
		code: "MX",
		dial_code: "+52",
		timezone: "GMT-08:00",
	},
	{
		name: "Micronesia (Federated States of)",
		currencyCode: null,
		code: "FM",
		dial_code: "+691",
		timezone: "UTC+10:00",
	},
	{
		name: "Moldova (Republic of)",
		currencyCode: "MDL",
		code: "MD",
		dial_code: "+373",
		timezone: "UTC+02:00",
	},
	{
		name: "Monaco",
		currencyCode: "EUR",
		code: "MC",
		dial_code: "+377",
		timezone: "UTC+01:00",
	},
	{
		name: "Mongolia",
		currencyCode: "MNT",
		code: "MN",
		dial_code: "+976",
		timezone: "UTC+07:00",
	},
	{
		name: "Montenegro",
		currencyCode: "EUR",
		code: "ME",
		dial_code: "+382",
		timezone: "UTC+01:00",
	},
	{
		name: "Montserrat",
		currencyCode: "XCD",
		code: "MS",
		dial_code: "+1664",
		timezone: "GMT-04:00",
	},
	{
		name: "Morocco",
		currencyCode: "MAD",
		code: "MA",
		dial_code: "+212",
		timezone: "GMT",
	},
	{
		name: "Mozambique",
		currencyCode: "MZN",
		code: "MZ",
		dial_code: "+258",
		timezone: "UTC+02:00",
	},
	{
		name: "Myanmar",
		currencyCode: "MMK",
		code: "MM",
		dial_code: "+95",
		timezone: "UTC+06:30",
	},
	{
		name: "Namibia",
		currencyCode: "NAD",
		code: "NA",
		dial_code: "+264",
		timezone: "UTC+01:00",
	},
	{
		name: "Nauru",
		currencyCode: "AUD",
		code: "NR",
		dial_code: "+674",
		timezone: "UTC+12:00",
	},
	{
		name: "Nepal",
		currencyCode: "NPR",
		code: "NP",
		dial_code: "+977",
		timezone: "UTC+05:45",
	},
	{
		name: "Netherlands",
		currencyCode: "EUR",
		code: "NL",
		dial_code: "+31",
		timezone: "GMT-04:00",
	},
	{
		name: "New Caledonia",
		currencyCode: "XPF",
		code: "NC",
		dial_code: "+687",
		timezone: "UTC+11:00",
	},
	{
		name: "New Zealand",
		currencyCode: "NZD",
		code: "NZ",
		dial_code: "+64",
		timezone: "GMT-11:00",
	},
	{
		name: "Nicaragua",
		currencyCode: "NIO",
		code: "NI",
		dial_code: "+505",
		timezone: "GMT-06:00",
	},
	{
		name: "Niger",
		currencyCode: "XOF",
		code: "NE",
		dial_code: "+227",
		timezone: "UTC+01:00",
	},
	{
		name: "Nigeria",
		currencyCode: "NGN",
		code: "NG",
		dial_code: "+234",
		timezone: "UTC+01:00",
	},
	{
		name: "Niue",
		currencyCode: "NZD",
		code: "NU",
		dial_code: "+683",
		timezone: "GMT-11:00",
	},
	{
		name: "Norfolk Island",
		currencyCode: "AUD",
		code: "NF",
		dial_code: "+672",
		timezone: "UTC+11:30",
	},
	{
		name: "Korea (Democratic People's Republic of)",
		currencyCode: "KPW",
		code: "KP",
		dial_code: "+850",
		timezone: "UTC+09:00",
	},
	{
		name: "Northern Mariana Islands",
		currencyCode: "USD",
		code: "MP",
		dial_code: "+1670",
		timezone: "UTC+10:00",
	},
	{
		name: "Norway",
		currencyCode: "NOK",
		code: "NO",
		dial_code: "+47",
		timezone: "UTC+01:00",
	},
	{
		name: "Oman",
		currencyCode: "OMR",
		code: "OM",
		dial_code: "+968",
		timezone: "UTC+04:00",
	},
	{
		name: "Pakistan",
		currencyCode: "PKR",
		code: "PK",
		dial_code: "+92",
		timezone: "UTC+05:00",
	},
	{
		name: "Palau",
		currencyCode: "(none)",
		code: "PW",
		dial_code: "+680",
		timezone: "UTC+09:00",
	},
	{
		name: "Palestine, State of",
		currencyCode: "ILS",
		code: "PS",
		dial_code: "+970",
		timezone: "UTC+02:00",
	},
	{
		name: "Panama",
		currencyCode: "PAB",
		code: "PA",
		dial_code: "+507",
		timezone: "GMT-05:00",
	},
	{
		name: "Papua New Guinea",
		currencyCode: "PGK",
		code: "PG",
		dial_code: "+675",
		timezone: "UTC+10:00",
	},
	{
		name: "Paraguay",
		currencyCode: "PYG",
		code: "PY",
		dial_code: "+595",
		timezone: "GMT-04:00",
	},
	{
		name: "Peru",
		currencyCode: "PEN",
		code: "PE",
		dial_code: "+51",
		timezone: "GMT-05:00",
	},
	{
		name: "Philippines",
		currencyCode: "PHP",
		code: "PH",
		dial_code: "+63",
		timezone: "UTC+08:00",
	},
	{
		name: "Pitcairn",
		currencyCode: "NZD",
		code: "PN",
		dial_code: "+64",
		timezone: "GMT-08:00",
	},
	{
		name: "Poland",
		currencyCode: "PLN",
		code: "PL",
		dial_code: "+48",
		timezone: "UTC+01:00",
	},
	{
		name: "Portugal",
		currencyCode: "EUR",
		code: "PT",
		dial_code: "+351",
		timezone: "GMT-01:00",
	},
	{
		name: "Puerto Rico",
		currencyCode: "USD",
		code: "PR",
		dial_code: "+1787",
		timezone: "GMT-04:00",
	},
	{
		name: "Qatar",
		currencyCode: "QAR",
		code: "QA",
		dial_code: "+974",
		timezone: "UTC+03:00",
	},
	{
		name: "Republic of Kosovo",
		currencyCode: "EUR",
		code: "XK",
		dial_code: "+383",
		timezone: "UTC+01:00",
	},
	{
		name: "Réunion",
		currencyCode: "EUR",
		code: "RE",
		dial_code: "+262",
		timezone: "UTC+04:00",
	},
	{
		name: "Romania",
		currencyCode: "RON",
		code: "RO",
		dial_code: "+40",
		timezone: "UTC+02:00",
	},
	{
		name: "Russian Federation",
		currencyCode: "RUB",
		code: "RU",
		dial_code: "+7",
		timezone: "UTC+03:00",
	},
	{
		name: "Rwanda",
		currencyCode: "RWF",
		code: "RW",
		dial_code: "+250",
		timezone: "UTC+02:00",
	},
	{
		name: "Saint Barthélemy",
		currencyCode: "EUR",
		code: "BL",
		dial_code: "+590",
		timezone: "GMT-04:00",
	},
	{
		name: "Saint Helena, Ascension and Tristan da Cunha",
		currencyCode: "SHP",
		code: "SH",
		dial_code: "+290",
		timezone: "UTC+00:00",
	},
	{
		name: "Saint Kitts and Nevis",
		currencyCode: "XCD",
		code: "KN",
		dial_code: "+1869",
		timezone: "GMT-04:00",
	},
	{
		name: "Saint Lucia",
		currencyCode: "XCD",
		code: "LC",
		dial_code: "+1758",
		timezone: "GMT-04:00",
	},
	{
		name: "Saint Martin (French part)",
		currencyCode: "EUR",
		code: "MF",
		dial_code: "+590",
		timezone: "GMT-04:00",
	},
	{
		name: "Saint Pierre and Miquelon",
		currencyCode: "EUR",
		code: "PM",
		dial_code: "+508",
		timezone: "GMT-03:00",
	},
	{
		name: "Saint Vincent and the Grenadines",
		currencyCode: "XCD",
		code: "VC",
		dial_code: "+1784",
		timezone: "GMT-04:00",
	},
	{
		name: "Samoa",
		currencyCode: "WST",
		code: "WS",
		dial_code: "+685",
		timezone: "UTC+13:00",
	},
	{
		name: "San Marino",
		currencyCode: "EUR",
		code: "SM",
		dial_code: "+378",
		timezone: "UTC+01:00",
	},
	{
		name: "Sao Tome and Principe",
		currencyCode: "STD",
		code: "ST",
		dial_code: "+239",
		timezone: "GMT",
	},
	{
		name: "Saudi Arabia",
		currencyCode: "SAR",
		code: "SA",
		dial_code: "+966",
		timezone: "UTC+03:00",
	},
	{
		name: "Senegal",
		currencyCode: "XOF",
		code: "SN",
		dial_code: "+221",
		timezone: "GMT",
	},
	{
		name: "Serbia",
		currencyCode: "RSD",
		code: "RS",
		dial_code: "+381",
		timezone: "UTC+01:00",
	},
	{
		name: "Seychelles",
		currencyCode: "SCR",
		code: "SC",
		dial_code: "+248",
		timezone: "UTC+04:00",
	},
	{
		name: "Sierra Leone",
		currencyCode: "SLL",
		code: "SL",
		dial_code: "+232",
		timezone: "GMT",
	},
	{
		name: "Singapore",
		currencyCode: "SGD",
		code: "SG",
		dial_code: "+65",
		timezone: "UTC+08:00",
	},
	{
		name: "Sint Maarten (DGMTh part)",
		currencyCode: "ANG",
		code: "SX",
		dial_code: "+1721",
		timezone: "GMT-04:00",
	},
	{
		name: "Slovakia",
		currencyCode: "EUR",
		code: "SK",
		dial_code: "+421",
		timezone: "UTC+01:00",
	},
	{
		name: "Slovenia",
		currencyCode: "EUR",
		code: "SI",
		dial_code: "+386",
		timezone: "UTC+01:00",
	},
	{
		name: "Solomon Islands",
		currencyCode: "SBD",
		code: "SB",
		dial_code: "+677",
		timezone: "UTC+11:00",
	},
	{
		name: "Somalia",
		currencyCode: "SOS",
		code: "SO",
		dial_code: "+252",
		timezone: "UTC+03:00",
	},
	{
		name: "South Africa",
		currencyCode: "ZAR",
		code: "ZA",
		dial_code: "+27",
		timezone: "UTC+02:00",
	},
	{
		name: "South Georgia and the South Sandwich Islands",
		currencyCode: "GBP",
		code: "GS",
		dial_code: "+500",
		timezone: "GMT-02:00",
	},
	{
		name: "Korea (Republic of)",
		currencyCode: "KRW",
		code: "KR",
		dial_code: "+82",
		timezone: "UTC+09:00",
	},
	{
		name: "South Sudan",
		currencyCode: "SSP",
		code: "SS",
		dial_code: "+211",
		timezone: "UTC+03:00",
	},
	{
		name: "Spain",
		currencyCode: "EUR",
		code: "ES",
		dial_code: "+34",
		timezone: "GMT",
	},
	{
		name: "Sri Lanka",
		currencyCode: "LKR",
		code: "LK",
		dial_code: "+94",
		timezone: "UTC+05:30",
	},
	{
		name: "Sudan",
		currencyCode: "SDG",
		code: "SD",
		dial_code: "+249",
		timezone: "UTC+03:00",
	},
	{
		name: "Suriname",
		currencyCode: "SRD",
		code: "SR",
		dial_code: "+597",
		timezone: "GMT-03:00",
	},
	{
		name: "Svalbard and Jan Mayen",
		currencyCode: "NOK",
		code: "SJ",
		dial_code: "+4779",
		timezone: "UTC+01:00",
	},
	{
		name: "Swaziland",
		currencyCode: "SZL",
		code: "SZ",
		dial_code: "+268",
		timezone: "UTC+02:00",
	},
	{
		name: "Sweden",
		currencyCode: "SEK",
		code: "SE",
		dial_code: "+46",
		timezone: "UTC+01:00",
	},
	{
		name: "Switzerland",
		currencyCode: "CHF",
		code: "CH",
		dial_code: "+41",
		timezone: "UTC+01:00",
	},
	{
		name: "Syrian Arab Republic",
		currencyCode: "SYP",
		code: "SY",
		dial_code: "+963",
		timezone: "UTC+02:00",
	},
	{
		name: "Taiwan",
		currencyCode: "TWD",
		code: "TW",
		dial_code: "+886",
		timezone: "UTC+08:00",
	},
	{
		name: "Tajikistan",
		currencyCode: "TJS",
		code: "TJ",
		dial_code: "+992",
		timezone: "UTC+05:00",
	},
	{
		name: "Tanzania, United Republic of",
		currencyCode: "TZS",
		code: "TZ",
		dial_code: "+255",
		timezone: "UTC+03:00",
	},
	{
		name: "Thailand",
		currencyCode: "THB",
		code: "TH",
		dial_code: "+66",
		timezone: "UTC+07:00",
	},
	{
		name: "Timor-Leste",
		currencyCode: "USD",
		code: "TL",
		dial_code: "+670",
		timezone: "UTC+09:00",
	},
	{
		name: "Togo",
		currencyCode: "XOF",
		code: "TG",
		dial_code: "+228",
		timezone: "GMT",
	},
	{
		name: "Tokelau",
		currencyCode: "NZD",
		code: "TK",
		dial_code: "+690",
		timezone: "UTC+13:00",
	},
	{
		name: "Tonga",
		currencyCode: "TOP",
		code: "TO",
		dial_code: "+676",
		timezone: "UTC+13:00",
	},
	{
		name: "Trinidad and Tobago",
		currencyCode: "TTD",
		code: "TT",
		dial_code: "+1868",
		timezone: "GMT-04:00",
	},
	{
		name: "Tunisia",
		currencyCode: "TND",
		code: "TN",
		dial_code: "+216",
		timezone: "UTC+01:00",
	},
	{
		name: "Turkey",
		currencyCode: "TRY",
		code: "TR",
		dial_code: "+90",
		timezone: "UTC+03:00",
	},
	{
		name: "Turkmenistan",
		currencyCode: "TMT",
		code: "TM",
		dial_code: "+993",
		timezone: "UTC+05:00",
	},
	{
		name: "Turks and Caicos Islands",
		currencyCode: "USD",
		code: "TC",
		dial_code: "+1649",
		timezone: "GMT-04:00",
	},
	{
		name: "Tuvalu",
		currencyCode: "AUD",
		code: "TV",
		dial_code: "+688",
		timezone: "UTC+12:00",
	},
	{
		name: "Uganda",
		currencyCode: "UGX",
		code: "UG",
		dial_code: "+256",
		timezone: "UTC+03:00",
	},
	{
		name: "Ukraine",
		currencyCode: "UAH",
		code: "UA",
		dial_code: "+380",
		timezone: "UTC+02:00",
	},
	{
		name: "United Arab Emirates",
		currencyCode: "AED",
		code: "AE",
		dial_code: "+971",
		timezone: "UTC+04",
	},
	{
		name: "United Kingdom",
		currencyCode: "GBP",
		code: "UK",
		dial_code: "+44",
		timezone: "GMT-08:00",
	},
	{
		name: "United Kingdom of Great Britain and Northern Ireland",
		currencyCode: "GBP",
		code: "GB",
		dial_code: "+44",
		timezone: "GMT-08:00",
	},
	{
		name: "United States of America",
		currencyCode: "USD",
		code: "US",
		dial_code: "+1",
		timezone: "GMT-12:00",
	},
	{
		name: "Uruguay",
		currencyCode: "UYU",
		code: "UY",
		dial_code: "+598",
		timezone: "GMT-03:00",
	},
	{
		name: "Uzbekistan",
		currencyCode: "UZS",
		code: "UZ",
		dial_code: "+998",
		timezone: "UTC+05:00",
	},
	{
		name: "Vanuatu",
		currencyCode: "VUV",
		code: "VU",
		dial_code: "+678",
		timezone: "UTC+11:00",
	},
	{
		name: "Venezuela (Bolivarian Republic of)",
		currencyCode: "VEF",
		code: "VE",
		dial_code: "+58",
		timezone: "GMT-04:00",
	},
	{
		name: "Viet Nam",
		currencyCode: "VND",
		code: "VN",
		dial_code: "+84",
		timezone: "UTC+07:00",
	},
	{
		name: "Wallis and Futuna",
		currencyCode: "XPF",
		code: "WF",
		dial_code: "+681",
		timezone: "UTC+12:00",
	},
	{
		name: "Western Sahara",
		currencyCode: "MAD",
		code: "EH",
		dial_code: "+212",
		timezone: "UTC+00:00",
	},
	{
		name: "Yemen",
		currencyCode: "YER",
		code: "YE",
		dial_code: "+967",
		timezone: "UTC+03:00",
	},
	{
		name: "Zambia",
		currencyCode: "ZMW",
		code: "ZM",
		dial_code: "+260",
		timezone: "UTC+02:00",
	},
	{
		name: "Zimbabwe",
		currencyCode: "BWP",
		code: "ZW",
		dial_code: "+263",
		timezone: "UTC+02:00",
	},
];

export const readOnlyFieldsForEmployee = [
	"employeeId",
	"designation",
	"dateOfJoining",
	"dateOfConfirmation",
];

export const employeeReadOnlyFieldsPaymentDetail = [
	"paymentMethod",
	"accountType",
	"ifsc",
	"routingNumber",
	"accountNumber",
	"upiId",
];

export const Details = [
	"firstName",
	"lastName",
	"employeeId",
	"aliasName",
	"emailId",
	"contact",
	"designation",
	"dateOfBirth",
	"gender",
	"maritalStatus",
	"passportNumber",
	"passportCountry",
	"dateOfJoining",
	"dateOfConfirmation",
	"locationValue",
	"reportingManagerId",
	"reportingManagerName",
];

export const Contact_Details = [
	"addressLine1",
	"addressLine2",
	"zipCode",
	"city",
	"state",
	"country",
];

export const Compensation_Details = [
	"employeeType",
	"ctc",
	"period",
	"effectiveDate",
	"defaultCompensation",
	"effectivePeriod",
	"compensation",
];

export const Payment_Details = [
	"paymentMethod",
	"accountType",
	"ifsc",
	"routingNumber",
	"accountNumber",
	"upiId",
	"bank",
];

export const employeeDetailDefaultValues = {
	firstName: "",
	lastName: "",
	country: [0],
	employeeType: "",
	period: { id: "365", name: "Per Year" },
	employeeId: "000",
	emailId: "",
	contact: "",
	designation: "",
	dateOfBirth: "",
	dateOfJoining: "",
	addressLine1: "",
	zipCode: "",
	city: "",
	state: "",
	ctc: "",
	paymentMethod: "",
	accountType: "",
	ifsc: "",
	accountNumber: "",
	isEffectiveSalary: false,
	inviteUserToFillInfo: false,
	bank: "",
	bankId: "",
	ratePerHour: "",
	hourlyWageDefaultHrs: "",
};

export const LOCATION_COLUMN_CONFIG = {
	name: "",
	type: "select",
	index: 4,
	options: [],
	required: false,
	width: 150,
	editable: false,
	hidden: false,
	uiVisible: true,
	columnCode: "",
	key: "",
	id: "",
	allowAddOption: false,
};

export const ADD_LOCATION_FIELDS = [
	{
		columnCode: "label",
		editable: true,
		hidden: false,
		id: "label",
		index: 0,
		name: "Name",
		required: true,
		type: "text",
		uiVisible: true,
		width: 100,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid Name",
		hasTooltip: false,
		tooltipText: "",
	},
	{
		columnCode: "title",
		editable: true,
		hidden: false,
		id: "title",
		index: 1,
		name: "Title for sales form",
		required: false,
		type: "text",
		uiVisible: true,
		width: 100,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a title",
		hasTooltip: false,
		tooltipText: "",
	},
	{
		columnCode: "address1",
		editable: true,
		hidden: false,
		id: "address1",
		index: 2,
		name: "Address",
		required: false,
		type: "text",
		uiVisible: true,
		width: 100,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid Address",
		hasTooltip: false,
		tooltipText: "",
	},
	{
		columnCode: "postalCode",
		editable: true,
		hidden: false,
		id: "postalCode",
		index: 3,
		name: "Postal Code",
		required: false,
		type: "text",
		uiVisible: true,
		width: 50,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid postal code",
		hasTooltip: false,
		tooltipText: "",
	},
	{
		columnCode: "state",
		editable: true,
		hidden: false,
		id: "state",
		index: 4,
		name: "State",
		required: false,
		type: "dropdown",
		uiVisible: true,
		options: [],
		width: 50,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid state",
		hasTooltip: false,
		tooltipText: "",
		searchableKey: "name",
	},
	{
		columnCode: "city",
		editable: true,
		hidden: false,
		id: "city",
		index: 5,
		name: "City",
		required: false,
		type: "text",
		uiVisible: true,
		width: 50,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid Name",
		hasTooltip: false,
		tooltipText: "",
	},
	{
		columnCode: "country",
		editable: true,
		hidden: false,
		id: "country",
		index: 6,
		name: "Country",
		required: false,
		type: "dropdown",
		uiVisible: true,
		options: Countries,
		width: 50,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid country",
		hasTooltip: false,
		tooltipText: "",
		searchableKey: "name",
	},
	{
		columnCode: "email",
		editable: true,
		hidden: false,
		id: "email",
		index: 7,
		name: "Email",
		required: false,
		type: "email",
		uiVisible: true,
		width: 100,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid email",
		hasTooltip: false,
		tooltipText: "",
	},
	{
		columnCode: "phone",
		editable: true,
		hidden: false,
		id: "phone",
		index: 8,
		name: "Phone",
		required: false,
		type: "text",
		uiVisible: true,
		width: 100,
		direction: "VERTICAL",
		readonly: false,
		hasError: false,
		errMsg: "Enter a valid phone",
		hasTooltip: false,
		tooltipText: "",
	},
];

export const SGPaymentMethods = [
	{
		id: 'directDeposit',
		name: 'Direct Deposit'
	},
	{
		id: 'cash',
		name: 'Cash'
	},
	{
		id: 'cheque',
		name: 'Cheque'
	}
];

export function getReportingManagerOptions(allEmployees, userId, includeNone) {
    const options = [];
    if (includeNone) {
        options.push(NONE_OPTION);
    }

    if (Array.isArray(allEmployees?.users)) {
        allEmployees.users.forEach((user) => {
            if (user.status === CONSTANTS.ACTIVE && user.userId !== userId) {
                options.push({
                    id: user.userId,
                    name: `${user.firstName} ${user.lastName}`,
                });
            }
        });
    }

    return options;
}

export default class EmployeeManager {
    static reportingManagers = [];

    static setReportingManagers(reportingManagers) {
        this.reportingManagers = reportingManagers;
    }

    static getReportingManagers() {
        return this.reportingManagers;
    }
}
